export const ADD_SYNC_ERROR = 'form/ADD_SYNC_ERROR';
export const REMOVE_SYNC_ERROR = 'form/REMOVE_SYNC_ERROR';
export const REMOVE_SUBMIT_ERROR = 'form/REMOVE_SUBMIT_ERROR';
